<ng-container *ngIf="isLoading$ | async"></ng-container>
<ngx-spinner></ngx-spinner>
<div class="page-title-area page-title-four">
  <div class="d-table">
    <div class="d-table-cell">
      <div class="page-title-item">
        <h2> {{'MENU.BOOKOFFER' | translate}} </h2>
        <ul>
          <li><a routerLink="/">{{'MENU.HOME' | translate}}</a></li>
          <li><i class="icofont-simple-right"></i></li>
          <li>{{'MENU.BOOKOFFER' | translate}}</li>
        </ul>
      </div>
    </div>
  </div>
</div>

<section class="appointment-area-two" style="margin-top: 20px;margin-bottom: -115px;">
  <div class="container">
    <div class="row align-items-center appointment-wrap-two">
      <div class="col-lg-12 wow animate__animated animate__fadeInUp" data-wow-delay=".3s">
        <div class="appointment-item appointment-item-two ">
          <div class="text-center" style="margin-bottom: 50px">
            <h2 style="font-weight: bold;font-size: 34px;">{{'MENU.BOOKOFFER' | translate}}</h2>
          </div>
          <div class="appointment-form">
            <div class="container">
              <div class="row">
                <div class="col-lg-6" style="font-size: 20px;">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="form-group">
                        <label style="font-weight: bold;">{{language == 'ar'? 'اختر العرض': 'Choose Offer'}}</label>
                        <select [(ngModel)]="OfferId" class="form-control" style="border-style: inset;"
                          (change)="OnChangeOffer($event)">
                          <option *ngFor="let Offer of Offers$" [value]="Offer.id">
                            {{ language == 'en'?Offer.nameEn: Offer.nameAr }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <div class="form-group">
                        <label style="font-weight: bold;">{{language == 'ar'? 'الاسم': 'Name'}}</label>
                        <input type="text" class="form-control" [(ngModel)]="ClientName" style="border-style: inset;">
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <div class="form-group">
                        <label style="font-weight: bold;">{{language == 'ar'? 'رقم الجوال': 'Mobile'}}</label>
                        <input type="number" class="form-control" [(ngModel)]="Mobile" style="border-style: inset;" min="1000000000" max="9999999999" oninput="if(this.value.length > 10) this.value = this.value.slice(0, 10);">
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <div class="form-group text-center">
                        <button style="font-weight: bold;" type="submit" class="btn btn-primary" (click)="onSubmit()">{{ 'COMMON.SUBMMIT' |
                          translate }}</button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-1 "></div>
                <div class="col-lg-5">
                  <a *ngIf="OfferData?.imagePath != null;else Offerimage"><img
                      [src]="OfferData?.imagePath | SafeUrlPipe" alt="Offer" style="border-radius: 10px;"> </a>
                  <ng-template #Offerimage><a></a></ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>